module.exports = __webpack_public_path__ + "80dd3e48338ee3ad06ce9955171bc6a4.svg";